var schema = 'http'
var host = '127.0.0.1'
if (window.location.host !== '127.0.0.1') {
  schema = 'https'
  host = window.location.host
}
var uri = schema + '://' + host

export default {
  serverURI: uri,
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js